import {getLocalData, removeLocalData, setLocalData} from "./StorageServices"
import {parseJwt} from "../helpers/parseToken"

const _store = {
    state: {
        accessToken: getLocalData('accessToken', ''),
        refreshToken: getLocalData('refreshToken', ''),
        user: getLocalData('user', {}),
        timeExp: getLocalData('timeExp', ''),
    },
    subscribers: []
}

const _broadcast = () => {
    setTimeout(() => {
        _store.subscribers.forEach(subscriber => {
            subscriber(_store.state)
        })
    }, 0)
}

export const notifyUpdate = _broadcast

export const subscribe = subscriber => {
    if (typeof subscriber !== 'function') return
    if (_store.subscribers.indexOf(subscriber) !== -1) return

    _store.subscribers = [].concat(_store.subscribers, subscriber)
}

export const unsubscribe = subscriber => {
    _store.subscribers = _store.subscribers.filter(sub => sub !== subscriber)
}

export const isAuthenticated = () => {
    const {state} = _store

    return !!state.accessToken
}

export const setUserPermissions = permissions => {
    _store.state = {
        ..._store.state,
        userPermissions: permissions
    }

    setLocalData('userPermission', permissions)
    removeLocalData('userRole')
    _broadcast()
}

export const getUserPermissions = () => getLocalData('userPermission') || _store.state.userPermissions || {}

export const isLegacyUserRoleOnly = () => !!getLocalData('userRole') && !getLocalData('userPermission')

export const setAccessToken = accessToken => {
    _store.state = {
        ..._store.state,
        accessToken,
    }

    setLocalData('accessToken', accessToken)
}

export const setRefreshToken = refreshToken => {
    _store.state = {
        ..._store.state,
        refreshToken,
    }

    setLocalData('refreshToken', refreshToken)
}

export const setTimeExp = timeExp => {
    _store.state = {
        ..._store.state,
        timeExp,
    }

    setLocalData('timeExp', timeExp)
}

export const getAccessToken = () => getLocalData('accessToken') || _store.state.accessToken || ''

export const getUserRoles = () => {
    try {
        const {roles} = parseJwt(getAccessToken())

        return Array.isArray(roles) ? roles : []
    } catch (e) {
        return []
    }
}

export const getRefreshToken = () => getLocalData('refreshToken') || _store.state.refreshToken || ''

export const getTimeExp = () => getLocalData('timeExp') || _store.state.timeExp || ''

export const logoutUser = (location = '') => {
    if(!!location) setLocalData('location', location)

    setAccessToken('')
    setRefreshToken('')
    setUserPermissions({})
    _broadcast()

    return true
}
